/**
 * Display helpers for patient identity fields.
 *
 * The backend can surface placeholder values when a study's DICOM had no
 * PatientID — most notably the literal string "UNKNOWN" for MRN, and "None"
 * derived from null name fields formatted into a string. We render these as
 * an em dash so the UI doesn't leak internal sentinel values.
 *
 * Centralising this here avoids the same fallback logic drifting between
 * the Uploads table, the Patients list, and the Reader sidebar.
 */

const DASH = '—';

const PLACEHOLDER_NAME_VALUES = new Set([
  '',
  'None',
  'None None',
  'Unknown',
  'UNKNOWN',
  'unknown',
]);

const PLACEHOLDER_MRN_VALUES = new Set([
  '',
  'Unknown',
  'UNKNOWN',
  'unknown',
  'None',
]);

export const displayPatientName = (name: string | null | undefined): string => {
  const v = (name ?? '').trim();
  return PLACEHOLDER_NAME_VALUES.has(v) ? DASH : v;
};

export const displayMrn = (mrn: string | null | undefined): string => {
  const v = (mrn ?? '').trim();
  return PLACEHOLDER_MRN_VALUES.has(v) ? DASH : v;
};

/**
 * True when an MRN is the shared "UNKNOWN" sentinel — used by the Patients
 * page to filter out the placeholder row from the visible list.
 */
export const isUnknownMrn = (mrn: string | null | undefined): boolean => {
  const v = (mrn ?? '').trim().toUpperCase();
  return v === 'UNKNOWN';
};
